import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  error(msg: string) {
    console.error(msg);
  }

  warn(msg: string) {
      console.log(msg);
  }

  info(msg: string) {
      console.log(msg);
  }

  debug(msg: string) {
    console.log(msg);
  }
}
